module.exports = __webpack_public_path__ + "img/high.42148d93.svg";